import { TemplatedExpressionEditor } from '@cotera/client/app/components/eraql-editor';
import { Assert } from '@cotera/utilities';
import { useState } from 'react';
import { ComboBoxValue } from '../../forms/combo-box';
import { Ty } from '@cotera/era';
import { Button } from '../../ui/button';
import { DG } from '@cotera/sdk/core';
import { Combobox } from '@cotera/client/v0/components/ui/combobox';

type FormField =
  | {
      t: 'attr';
      value: string;
    }
  | {
      t: 'expression';
      value: string;
    }
  | {
      t: 'unset';
    };

export const ComboBoxWithExpression: React.FC<{
  onChange: (value: FormField) => void;
  fieldValue: FormField;
  optional: boolean;
  attributes: Record<string, Ty.ExtendedAttributeType>;
  options: ComboBoxValue[];
  placeholder?: string;
}> = ({ onChange, fieldValue, attributes, options, placeholder }) => {
  const [useExpressionEditor, setUseExpressionEditor] = useState(
    fieldValue.t === 'expression'
  );
  const changeHandler = (v: string) => {
    if (v.startsWith('=') && !useExpressionEditor) {
      onChange({
        t: 'expression',
        value: '',
      });
      setUseExpressionEditor(true);
    } else {
      if (v === '') {
        onChange({
          t: 'unset',
        });
      } else {
        onChange({
          t: 'attr',
          value: v,
        });
      }
    }
  };

  Assert.assert(
    fieldValue !== undefined &&
      (fieldValue.t === 'attr' ||
        fieldValue.t === 'expression' ||
        fieldValue.t === 'unset'),
    `Expected attr, got ${fieldValue?.t}`
  );

  const value = fieldValue.t === 'unset' ? '' : fieldValue.value;

  if (useExpressionEditor) {
    return (
      <div className="rounded flex items-center gap-2 mb-4">
        <TemplatedExpressionEditor
          inline
          templated={false}
          parser={DG.Graph.GraphRelativeParserForRel.fromRel({ attributes })}
          eraql={value}
          onChange={(v) => {
            onChange({
              t: 'expression',
              value: v,
            });
          }}
        />
        <Button
          icon="close"
          inline
          theme="error"
          onClick={() => {
            setUseExpressionEditor(false);
          }}
        />
      </div>
    );
  }

  return (
    <Combobox
      items={options.map((o) => ({ value: o.value, label: o.display }))}
      value={value}
      onChange={(value) => {
        changeHandler(value);
      }}
      placeholder={placeholder}
    />
  );
};
